export const leftPad = (value: number, totalWidth: number, paddingChar?: string) => {
    var length = totalWidth - value.toString().length + 1;

    const formattedValue = Array(length).join(paddingChar ?? "0") + value;

    return value > (10 ^ totalWidth) ? `${value}` : formattedValue;
};
